import {
  RunInstructionsPayload,
  Workflow,
  WorkflowAttributes,
  WorkflowDefinition,
  WorkflowDetailed,
  WorkflowType,
} from '@automata/api/apiSchemas';

import { ApiEditor } from 'components/ApiEditor';
import { GitEditor } from 'components/GitEditor';
import { initialGitWorkflow } from 'components/GitEditor/defs/initialState';
import { MaestroEditor } from 'components/MaestroEditor';
import { initialMaestroWorkflow } from 'components/MaestroEditor/defs/initialState';
import { TextEditor } from 'components/TextEditor';

export interface EditorProps {
  name: string;
  updateData: (
    definition: WorkflowDefinition,
    attributes?: WorkflowAttributes,
    runInstructions?: RunInstructionsPayload
  ) => Promise<WorkflowDetailed | undefined>;
  requestData: WorkflowDetailed | undefined;
  onContentUpdated: (a: Workflow | null | undefined) => void;
  workflow?: WorkflowDetailed;
  useWorkcellTransportConfig?: boolean;
  onUseWorkcellTransportConfigChange?: (value: boolean) => void;
}

export type WorkflowBehaviour = {
  label: string;
  canDeployDirectly: boolean;
  initialDefinition: WorkflowDefinition;
  Editor: React.FunctionComponent<EditorProps>;
  enabled?: boolean;
};

export const behaviours: Record<WorkflowType, WorkflowBehaviour> = {
  python: {
    canDeployDirectly: true,
    label: 'Script',
    initialDefinition: {
      python: '',
    },
    Editor: TextEditor,
    enabled: true,
  },
  git: {
    canDeployDirectly: true,
    label: 'Git',
    initialDefinition: {
      git: initialGitWorkflow,
    },
    Editor: GitEditor,
    enabled: true,
  },
  maestro: {
    canDeployDirectly: true,
    label: 'Scheduler Configuration',
    initialDefinition: {
      maestro: initialMaestroWorkflow,
    },
    Editor: MaestroEditor,
    enabled: true,
  },
  api: {
    canDeployDirectly: false,
    label: 'API Configuration',
    initialDefinition: {
      api: {
        cached_api_definition: '',
        cached_maestro_workflow: initialMaestroWorkflow,
        parameter_values: [],
        batches: 0,
      },
    },
    Editor: ApiEditor,
    enabled: false,
  },
  canvas: {
    canDeployDirectly: false,
    label: 'Canvas',
    initialDefinition: {
      api: {
        cached_api_definition: '',
        cached_maestro_workflow: initialMaestroWorkflow,
        parameter_values: [],
        batches: 0,
      },
    },
    Editor: ApiEditor,
    enabled: false,
  },
  sdk: {
    canDeployDirectly: false,
    label: 'SDK',
    initialDefinition: {
      api: {
        cached_api_definition: '',
        cached_maestro_workflow: initialMaestroWorkflow,
        parameter_values: [],
        batches: 0,
      },
    },
    Editor: ApiEditor,
    enabled: false,
  },
};

export const getWorkflowBehaviour = (type: WorkflowType): WorkflowBehaviour => {
  return behaviours[type];
};
